// scholar.js

import request from '@/utils/request';

export function getScholarInfo() {
  return request({
    url: '/v1/scholar_info',
    method: 'get',
  });
}

export function putScholarInfo(data) {
  return request({
    url: '/v1/scholar_info',
    method: 'put',
    data: data,
  });
}
